import { useState } from "react";
import { FaTimes } from "react-icons/fa";
import Navbar from "../components/Layout/Navbar";
import Footer from "../components/Layout/Footer";
import regionalMap from "../Regional Map (Last Update).jpg";
import languageMap from "../Map of Estimate Distribute Language in Regional ASED.jpg";
import regionalGazetteerPdf from "../assets/files/Regional Gazetteer.xlsx - Regional Gazetteer.pdf";
import regionalGenericTermsPdf from "../assets/files/THE GENERIC TERMS IN THE REGION OF UNGEGN ASE_INDONESIA_CORR.pdf";

function Publications() {
  const [previewDoc, setPreviewDoc] = useState(null);

  return (
    <>
      <Navbar />

      <div className="container mx-auto px-20">
        {/* Regional Maps */}
        <div className="mt-6 mb-6">
          <h2 className="text-2xl font-semibold mb-8">Regional Maps</h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 py-8">
            <div className="border rounded overflow-hidden shadow hover:shadow-lg transition text-center">
              <a href={regionalMap} target="_blank" rel="noopener noreferrer">
                <img
                  src={regionalMap}
                  alt="Regional Map"
                  className="w-full h-64 object-contain"
                />
              </a>
              <div className="p-3 bg-gray-50 text-sm font-medium">
                Regional Map
              </div>
            </div>

            <div className="border rounded overflow-hidden shadow hover:shadow-lg transition text-center">
              <a href={languageMap} target="_blank" rel="noopener noreferrer">
                <img
                  src={languageMap}
                  alt="Language Map"
                  className="w-full h-64 object-contain"
                />
              </a>
              <div className="p-3 bg-gray-50 text-sm font-medium">
                Map of Estimate Distribution Language in Regional Asia South East Division
              </div>
            </div>
          </div>
        </div>

        {/* Gazetteer & Generic Terms */}
        <div className="mt-6 mb-6">
          <h2 className="text-2xl font-semibold mb-8">
            Regional Gazetteer & Generic Term
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 py-8">
            <button
              type="button"
              onClick={() =>
                setPreviewDoc({
                  document_name: "Regional Gazetteer",
                  file_url: regionalGazetteerPdf,
                })
              }
              className="border rounded overflow-hidden shadow hover:shadow-lg transition text-center bg-white"
            >
              <div className="relative w-full h-64 bg-gray-100">
                <iframe
                  src={`${regionalGazetteerPdf}#toolbar=0&navpanes=0&scrollbar=0`}
                  title="Regional Gazetteer thumbnail"
                  className="w-full h-full border-0 pointer-events-none"
                />
                <div className="absolute inset-x-0 bottom-0 bg-black/50 text-white text-xs py-2">
                  Click to preview document
                </div>
              </div>
              <div className="p-3 bg-gray-50 text-sm font-medium">
                Regional Gazetteer
              </div>
            </button>

            <button
              type="button"
              onClick={() =>
                setPreviewDoc({
                  document_name: "Regional Generic Terms",
                  file_url: regionalGenericTermsPdf,
                })
              }
              className="border rounded overflow-hidden shadow hover:shadow-lg transition text-center bg-white"
            >
              <div className="relative w-full h-64 bg-gray-100">
                <iframe
                  src={`${regionalGenericTermsPdf}#toolbar=0&navpanes=0&scrollbar=0`}
                  title="Regional Generic Terms thumbnail"
                  className="w-full h-full border-0 pointer-events-none"
                />
                <div className="absolute inset-x-0 bottom-0 bg-black/50 text-white text-xs py-2">
                  Click to preview document
                </div>
              </div>
              <div className="p-3 bg-gray-50 text-sm font-medium">
                Regional Generic Terms
              </div>
            </button>
          </div>
        </div>
      </div>

      {previewDoc && previewDoc.file_url && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded shadow-lg w-11/12 h-[80vh] flex flex-col">
            <div className="flex justify-between items-center p-4 border-b">
              <span className="font-medium text-sm">{previewDoc.document_name}</span>
              <button
                type="button"
                onClick={() => setPreviewDoc(null)}
                className="text-gray-600 hover:text-red-600"
                title="Close"
              >
                <FaTimes className="text-lg" />
              </button>
            </div>
            <div className="flex-1">
              <iframe
                src={previewDoc.file_url}
                title={previewDoc.document_name}
                className="w-full h-full border-0"
              />
            </div>
          </div>
        </div>
      )}

      <Footer />
    </>
  );
}

export default Publications;
